import { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import debounce from 'lodash.debounce';

import { CartLineItem } from 'common/api/e-comm/models/CartLineItem';
import { editCartLineItemThunk } from 'common/features/store/duck/cart/duck';
import { isInIframe, mainWebsiteOrigin } from 'utils';

export const useQuantityControls = (
    item: CartLineItem,
    setShowItemUpdateErrorModal: (_: boolean) => void,
    setUpdatingLineItem: React.Dispatch<React.SetStateAction<boolean>> | ((_: boolean) => void)
) => {
    const dispatch = useDispatch<any>();
    const [quantity, setQuantity] = useState<number>(item.quantity);
    const itemQt = item.quantity;

    const decrement = () => setQuantity((qt) => qt - 1);
    const increment = () => setQuantity((qt) => qt + 1);

    // CASE: update the cart line item's quantity after `quantity`
    // gets updated.  We should debounce this.
    useEffect(() => {
        if (quantity > 0 && itemQt !== quantity) {
            updateLineItem(quantity);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [quantity, itemQt]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const updateLineItem = useCallback(
        debounce(async (quantity: number) => {
            setUpdatingLineItem(true);

            const response = await editCartLineItemThunk({ quantity, id: item.id })(dispatch);

            if (response.error) {
                setQuantity(item.quantity);
                setShowItemUpdateErrorModal(true);
            }
            if (isInIframe()) {
                window.parent.postMessage({ type: 'cartUpdated' }, mainWebsiteOrigin());
            }
            setUpdatingLineItem(false);
        }, 800),
        [item]
    );

    return {
        decrement,
        increment,
        quantity,
    };
};
